module.exports = __webpack_public_path__ + "img/booing_no_data.d291b1c6.png";